import { RouterModule, Routes } from '@angular/router';

import { routes as qualityIssuesRoutes } from './claim/claim.routes';
import { routes as GuaranteeRoutes } from './guarantee/guarantee.routes';
import { OfferLineListComponent } from './offer/components/offer-list/offer-line-list.component';
import { routes as offerRoutes } from './offer/offer.routes';
import { routes as productRoutes } from './product/product.routes';
import { routes as needRoutes } from './need4steel/needsteel.routes';
import { routes as eorderRoutes } from './eorder/eorder.routes';
import { routes as fastlaneRoutes } from './fastlane/fastlane.routes';
import { GuaranteeListComponent } from './guarantee/components/list/guarantee-list.component';
import { SearchBatchListComponent } from './order/components/search-list/search-batch-list.component';
import { SearchOrderListComponent } from './order/components/search-list/search-order-list.component';
import { SearchShipmentListComponent } from './order/components/search-list/search-shipment-list.component';
import {
	SearchDispatchAdviceListComponent
} from './order/components/search-list/search-dispatch-advice-list.component';
import { SearchInvoiceListComponent } from './order/components/search-list/search-invoice-list.component';
import { SearchCertificateListComponent } from './order/components/search-list/search-certificate-list.component';
import { SearchFastLaneListComponent } from './fastlane/components/search-list/search-fastlane-list.component';
import {
	SearchOrderAcknowledgementListComponent
} from './order/components/search-list/search-order-acknowledgment-list.component';
import { routes as orderTrackingRoutes } from './order/order.routes';
import { routes as organizationRoutes } from './organization/organization.routes';
import { routes as usersRoutes } from './users/user.routes';
import { routes as ecallOffRoutes } from './ecall-off/ecall-off.routes';
import { routes as commercialDocumentRoutes } from './commercial-documents/documents.routes';
import { routes as administrationRoutes } from './administration/administration.routes';
import { SkeletonComponent } from './shared/components/base/skeleton.component';
import { DashboardComponent } from './shared/components/dashboard/dashboard.component';
import { backGuard } from './shared/components/guards/back.guard';
import { userGuard } from './shared/components/guards/user.guard';
import { NotFoundComponent } from './shared/components/notfound/notfound.component';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import { SearchResultsComponent } from './shared/components/search/search-results.component';
import { SERVICE_ANALYTICS } from './shared/models/list';
import { routes as auctionRoutes } from './auction/auction.routes';
import { routes as userRoutes } from './user-management/user.routes';
import { LegalDataComponent } from './shared/components/legal/legal-data.component';
import { GuaranteeDocumentComponent } from './shared/components/guarantee-document/guarantee-document.component';
import { NewsCardComponent } from './shared/components/news-card/news-card.component';
import { NewsListComponent } from './shared/components/news-list/news-list.component';
import { HelpDataComponent } from './shared/components/help/help-data.component';
import { ClaimListComponent } from './claim/components/list/claim-list.component';
import { ListFilterComponent } from './shared/components/filter/list-filter.component';
import { AllDatacenterAccessComponent } from './shared/datacenter/all-datacenter-access.component';
import { SearchSBOrderListComponent } from './order/components/search-list/search-sb-order-list.component';
import { OrderServicesMenuComponent } from './shared/components/order-services-menu/order-services-menu.component';
import { SalesServicesMenuComponent } from './shared/components/sales-services-menu/sales-services-menu.component';
import {
	QualityServicesMenuComponent
} from './shared/components/quality-services-menu/quality-services-menu.component';
import { routes as coilCalculatorRoutes } from './calculator/coil-calculator.routes';
import { routes as aqdbRoutes } from './aqdb/aqdb.routes';
import { routes as efeasibilityRoutes } from './efeasibility/efeasibility.routes';

const rootRoutes: Routes = [
	{
		path: 'redirect',
		component: RedirectComponent,
		pathMatch: 'full',
		data: { pageName: 'Redirect' }
	},
	{
		path: '',
		canActivate: [backGuard, userGuard],
		runGuardsAndResolvers: 'always',
		component: SkeletonComponent,
		children: [
			{
				path: '',
				redirectTo: 'home',
				pathMatch: 'full',
				data: { pageName: 'Redirect' }
			},
			{
				path: 'dashboard',
				redirectTo: 'home',
				pathMatch: 'full',
				data: { pageName: 'Home', service: SERVICE_ANALYTICS.COMMON }
			},
			{
				path: 'home',
				children: [
					{
						path: '',
						component: DashboardComponent,
						data: { pageName: 'Home', service: SERVICE_ANALYTICS.COMMON }
					},
					{
						path: 'news-card/:cardId',
						component: NewsCardComponent,
						data: { pageName: 'Home - News Card', service: SERVICE_ANALYTICS.COMMON }
					},
					{
						path: 'news-list',
						component: NewsListComponent,
						data: { pageName: 'Home - News List', service: SERVICE_ANALYTICS.COMMON }
					},
					{
						path: 'all-datacenter',
						component: AllDatacenterAccessComponent,
						data: { pageName: 'Home - All Datacenter Access', service: SERVICE_ANALYTICS.COMMON }
					},
					{
						path: 'order-services',
						component: OrderServicesMenuComponent,
						data: { pageName: 'Home - Order Services Menu', service: SERVICE_ANALYTICS.ORDER_TRACKING }
					},
					{
						path: 'sales-services',
						component: SalesServicesMenuComponent,
						data: { pageName: 'Home - Sales Services Menu', service: SERVICE_ANALYTICS.SALES }
					},
					{
						path: 'quality-services',
						component: QualityServicesMenuComponent,
						data: { pageName: 'Home - Quality Services Menu', service: SERVICE_ANALYTICS.QUALITY }
					}
				]
			},
			{
				path: 'order-tracking',
				children: orderTrackingRoutes,
			},
			{
				path: 'organizations',
				children: organizationRoutes,
			},
			{
				path: 'users',
				children: usersRoutes,
			},
			{
				path: 'ecall-off',
				children: ecallOffRoutes,
			},
			{
				path: 'commercial-documents',
				children: commercialDocumentRoutes,
			},
			{
				path: 'administration',
				children: administrationRoutes,
			},
			{
				path: 'quality-issues',
				children: qualityIssuesRoutes,
			},
			{
				path: 'guarantee-requests',
				children: GuaranteeRoutes,
			},
			{
				path: 'offer',
				children: offerRoutes,
			},
			{
				path: 'need4steel',
				children: needRoutes,
			},
			{
				path: 'order',
				children: eorderRoutes,
			},
			{
				path: 'fastlane',
				children: fastlaneRoutes,
			},
			{
				path: 'product',
				children: productRoutes,
			},
			{
				path: 'user',
				children: userRoutes,
			},
			{
				path: 'auction',
				children: auctionRoutes,
			},
			{
				path: 'calculator',
				children: coilCalculatorRoutes,
			},
			{
				path: 'search',
				data: { service: SERVICE_ANALYTICS.SEARCH },
				children: [
					{
						path: '',
						component: SearchResultsComponent,
						data: { pageName: 'Global Search' }
					},
					{
						path: ':query',
						children: [
							{
								path: '',
								component: SearchResultsComponent,
								data: { pageName: 'Global Search' }
							},
							{
								path: 'offers/:status',
								component: OfferLineListComponent,
								data: { pageName: 'Global Search - Offers', service: SERVICE_ANALYTICS.EOFFER }
							},
							{
								path: 'orders',
								component: SearchOrderListComponent,
								data: { pageName: 'Global Search - Orders', service: SERVICE_ANALYTICS.ORDER_SPOT }
							},
							{
								path: 'schedule-business-orders',
								component: SearchSBOrderListComponent,
								// eslint-disable-next-line @stylistic/max-len
								data: { pageName: 'Global Search - Schedule Business Orders', service: SERVICE_ANALYTICS.ORDER_SCHEDULE }
							},
							{
								path: 'batches',
								component: SearchBatchListComponent,
								data: { pageName: 'Global Search - Batches', service: SERVICE_ANALYTICS.BATCH }
							},
							{
								path: 'shipments',
								component: SearchShipmentListComponent,
								data: { pageName: 'Global Search - Shipments', service: SERVICE_ANALYTICS.SHIPMENT }
							},
							{
								path: 'claims',
								children: [
									{
										path: '',
										component: ClaimListComponent,
										data: {
											pageName: 'Global Search - Quality Issues',
											service: SERVICE_ANALYTICS.QUALITY_ISSUE,
											type: 'quality',
										}
									},
									{
										path: 'filter',
										component: ListFilterComponent,
										data: { pageName: 'Quality Issues - Filter', service: SERVICE_ANALYTICS.CLAIM }
									}
								]
							},
							{
								path: 'guarantee-requests',
								children: [
									{
										path: '',
										component: GuaranteeListComponent,
										data: {
											pageName: 'Global Search - Guarantees',
											service: SERVICE_ANALYTICS.GUARANTEE,
											type: 'guarantee',
										}
									},
									{
										path: 'filter',
										component: ListFilterComponent,
										// eslint-disable-next-line @stylistic/max-len
										data: { pageName: 'Guarantee Requests - Filter', service: SERVICE_ANALYTICS.GUARANTEE }
									}
								]
							},
							{
								path: 'dispatch-advices',
								component: SearchDispatchAdviceListComponent,
								data: {
									pageName: 'Global Search - Dispatch Advice',
									service: SERVICE_ANALYTICS.DISPATCH_ADVICE,
								},
							},
							{
								path: 'invoice',
								component: SearchInvoiceListComponent,
								data: { pageName: 'Global Search - Invoices', service: SERVICE_ANALYTICS.INVOICE }
							},
							{
								path: 'certificate',
								component: SearchCertificateListComponent,
								data: {
									pageName: 'Global Search - Certificates',
									service: SERVICE_ANALYTICS.CERTIFICATE
								}
							},
							{
								path: 'order-acknowledgments',
								component: SearchOrderAcknowledgementListComponent,
								data: {
									pageName: 'Global Search - Order Acknowledgments',
									service: SERVICE_ANALYTICS.ORDER_ACKNOWLEDGMENT,
								}
							},
							{
								path: 'fastlane',
								component: SearchFastLaneListComponent,
								data: {
									pageName: 'Global Search - FastLane',
									service: SERVICE_ANALYTICS.FASTLANE,
								}
							}
						]
					}
				]
			},
			{
				path: 'legal-informations',
				component: LegalDataComponent,
				data: { pageName: 'Legal Information', service: SERVICE_ANALYTICS.COMMON }
			},
			{
				path: 'guarantee-documents',
				component: GuaranteeDocumentComponent,
				data: { pageName: 'Guarantee Documents', service: SERVICE_ANALYTICS.COMMON }
			},
			{
				path: 'help-documents',
				component: HelpDataComponent,
				data: { pageName: 'Help Documents', service: SERVICE_ANALYTICS.COMMON }
			},
			{
				path: 'aqdb',
				children: aqdbRoutes,
			},
			{
				path: 'efeasibility',
				children: efeasibilityRoutes,
			}
		]
	},
	{
		path: '**',
		component: NotFoundComponent,
		data: { pageName: 'Error', service: SERVICE_ANALYTICS.NOTFOUND }
	}
];

export const routing = RouterModule.forRoot(rootRoutes, { onSameUrlNavigation: 'reload' });
